//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum ReservationInvitationStatus {

  Accepted = 1,

  Declined = 2,

  Sent = 3,

}

export default ReservationInvitationStatus;